import { render } from "./PolarAreaChart.vue?vue&type=template&id=39b43453&ts=true"
import script from "./PolarAreaChart.vue?vue&type=script&lang=ts"
export * from "./PolarAreaChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__